import { createGlobalStyle } from "styled-components";

export const customFormItemClass = "custom-form-item";
export const GlobalStyles = createGlobalStyle`
  .${customFormItemClass} {
    margin-bottom: 0;

    .ant-form-item-control {
      flex: unset;
    }
  }
`;
